import React, { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { Layout, Menu, Button, Badge, Dropdown, List, Avatar, Typography } from 'antd';
import { PieChartOutlined, FileDoneOutlined, BulbOutlined, EnvironmentOutlined, MonitorOutlined, SafetyCertificateOutlined, MenuUnfoldOutlined, MenuFoldOutlined, HomeFilled, LogoutOutlined, BellOutlined } from '@ant-design/icons';

const { Header, Content, Sider } = Layout;
const { Text } = Typography;

const items = [
    {
        key: '1',
        icon: <HomeFilled />,
        label: <Link to="/">Home</Link>,
    },
    {
        key: '2',
        label: <Link to="/data-visualization">Data Visualization</Link>,
        icon: <PieChartOutlined />,
    },
    {
        key: '3',
        icon: <FileDoneOutlined />,
        label: <Link to="/reports">Reports</Link>,
    },
    {
        key: '4',
        icon: <SafetyCertificateOutlined />,
        label: <Link to="/compliance">Compliance & Certification</Link>,
    },
    {
        key: '5',
        icon: <EnvironmentOutlined />,
        label: <Link to="/supply-chain-tracking">Supply Chain Tracking</Link>,
    },
    {
        key: '6',
        icon: <MonitorOutlined />,
        label: <Link to="/environmental-monitoring">Environmental Monitoring</Link>,
    },
    {
        key: '7',
        icon: <BulbOutlined />,
        label: <Link to="/recommendations">Recommendations</Link>,
    },
];


const notifications = [
    {
        id: 1,
        title: 'Poor Drainage',
        description: 'Optimal Range: 10% - 30%',
        explanation:
            'Affects water retention and tillage practices.',
        recommendation:
            'Amend with gypsum; for sandy soils, add organic matter.',
    },
];


const Sidebar = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const handleLogout = () => {
        setTimeout(() => {
            localStorage.removeItem('token'); // Clear token
            localStorage.removeItem('expires_in'); // Clear token
            navigate('/login'); // Redirect to login page
        }, 1000); 
    };


    const notificationMenu = (
        <div
            style={{
                width: 320,
                maxHeight: 400,
                overflowY: 'auto',
                background: '#fff',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                padding: '10px',
            }}
        >
            <Text strong style={{ fontSize: '16px' }}>
                Notifications
            </Text>

            <List
                itemLayout="horizontal"
                dataSource={notifications}
                renderItem={(item) => (
                    <List.Item>
                        <List.Item.Meta
                            avatar={
                                <Avatar
                                    style={{
                                        backgroundColor: '#ACD6AC',
                                        color: '#335001',
                                    }}
                                    icon={<BellOutlined />}
                                />
                            }
                            title={
                                <div>
                                    <Text strong>{item.title} for SU13C</Text>
                                </div>
                            }
                            description={
                                <div>
                                    <div>{item.description}</div>
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
    );


    return (
        <Layout>
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                breakpoint="lg"
                collapsedWidth="0"
                style={{ minHeight: '100vh', backgroundColor: '#ACD6AC'}}
                width={270}
                className="sidebar"
                onBreakpoint={(broken) => {
                    if (broken) setCollapsed(true);
                }}
            >
                <div className="logo">
                    <img src={`${process.env.PUBLIC_URL}/images/theros_logo.png`} alt="Theros" style={{ width: '200px' }}></img>
                </div>
                <Menu style={{ backgroundColor: 'transparent', fontSize: '16px', paddingTop: '30px', fontWeight: 700}} mode="inline" defaultSelectedKeys={['1']} items={items} />
            </Sider>
            <Layout style={{ zIndex: 2 }}>
                <Header className="site-layout-background" style={{ padding: 0, backgroundColor: '#ACD6AC' }}>
                    <div className="header-content" style={{ height: '100%' }}>
                        <div className="left-navbar">
                            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                className: 'trigger',
                                onClick: toggleCollapsed,
                            })}
                        </div>
                        <div className="right-navbar">
                             <Dropdown
                                dropdownRender={() => notificationMenu}
                                trigger={['click']}
                                placement="bottomRight"
                            >
                                <Button
                                    style={{
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                        marginRight: 20
                                    }}
                                >
                                    <Badge count={notifications.length} size="small">
                                        <BellOutlined
                                            style={{
                                                fontSize: '30px',
                                                color: '#335001',
                                            }}
                                        />
                                    </Badge>
                                </Button>
                            </Dropdown>
                            <Button style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }} icon={<LogoutOutlined style={{ fontSize: '30px', color: '#335001' }}/>} onClick={handleLogout} />
                        </div>
                    </div>
                </Header>
                <Content
                style={{
                    // margin: '24px 16px',
                    padding: 36,
                    background: '#F6FFF4',
                    minHeight: 280,
                }}
                >
                    <Outlet />  {/* This is where the routed content will be rendered */}
                </Content>
            </Layout>
        </Layout>
    );
};

export default Sidebar;